import { mechanismList } from "@/mocks/editorial";
import SectionHeader from "./SectionHeader";

export default function BlastSection() {
  return (
    <section id="blast" className="scroll-mt-24 bg-background-100 py-12 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHeader
          align="center"
          kicker="为何会爆 · 机制拆解"
          title="瓜“爆”的四台引擎"
          desc="热度从来不是随机降临的。把一次真正的爆发拆开来看，几乎都能找到四台引擎在同时运转——它们一起点火，才烧出我们看到的漫天花雨。"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
          {mechanismList.map((m) => (
            <article
              key={m.no}
              className="relative flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-6 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="flex items-start justify-between">
                <span className="font-heading text-4xl font-semibold text-secondary-300">
                  {m.no}
                </span>
                <span className="grid h-11 w-11 place-items-center rounded-xl bg-primary-500 text-background-50">
                  <i className={`${m.icon} text-xl`}></i>
                </span>
              </div>
              <h3 className="mt-5 font-heading text-xl font-semibold text-foreground-950">
                {m.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                {m.body}
              </p>
              <p className="mt-5 border-t border-dashed border-background-200 pt-4 text-xs font-medium text-accent-700">
                <i className="ri-lightbulb-line mr-1"></i>
                {m.point}
              </p>
            </article>
          ))}
        </div>

        <p className="mt-10 text-center text-sm text-foreground-600">
          <i className="ri-question-line mr-1 text-accent-600"></i>
          想判断一个热点会不会继续涨？先看它“缺不缺关键信息、情绪够不够强、转发划不划得来”。
        </p>
      </div>
    </section>
  );
}